module.exports = __webpack_public_path__ + "static/media/chrome devtools.94632f8f.png";